module.exports = __webpack_public_path__ + "resources/icon_44_favor.a5d0318433b350b6.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_favor.png
// module id = 454
// module chunks = 0 1 2 3 4